export const auth = {
  resendOTP: 'We’ve sent an OTP to register email and phone number',
  verifiedEmail: 'Email verified!',
  verifiedOTP: 'OTP verified!',
  forgotOTPResend: 'OTP sent on your provided email or phone number!',
  register: 'Registered successfully!',
  login: 'Logged in successfully!',
  passwordReset: 'Password reset successfully',
}
export const kyc = {
  feedbackSent: 'Feedback sent successfully!',
  submitSuccess: 'KYC submitted successfully!',
}
export const profile = {
  updateProfile: 'Profile updated successfully!',
  reverify: 'We’ve sent an OTP to your updated email and phone number',
}
export const catalogue = {
  added: 'Product details added successfully!',
  draft: 'Product details saved as draft!',
  updated: 'Product details updated successfully!',
  variantUpdated: 'Variant details updated successfully!',
  deleted: 'Product deleted successfully!',
}

export const masterToast = {
  addBrand: "Yay! Brand details added successfully!",
  editBrand: "Success! Brand details updated successfully!",
  deleteBrand: "Done! Brand details deleted successfully!",
  addPrimaryCategory: "Great job! Primary category added successfully!",
  editPrimaryCategory: "Awesome! Primary category updated successfully!",
  addSubCategory: "Fantastic! Sub category added successfully!",
  deleteCategory: "Done! Category deleted successfully!",
  editSubCategory: "Superb! Sub category updated successfully!",
  addGroupCategory: "Exciting news! Group category added successfully!",
  editGroupCategory: "Amazing! Group category updated successfully!",
  addVariant: "Woohoo! Product variant added successfully!",
  editVariant: "Good news! Product variant updated successfully!",
  deleteVariant: "Product Variant deleted successfully!",
  deleteSubcategoryVariant:
    "Say goodbye! Sub category variant deleted successfully!",
  deletedVariant: "Farewell! Variant deleted successfully!",
  addRoles: "Kudos! Roles & permission added successfully!",
  editRole: "Bravo! Roles & permission updated successfully!",
  deleteRole: "Farewell! Roles & permission deleted successfully!",
  addUserManagement: "Welcome aboard! User added successfully!",
  editUserManagement: "Success! User updated successfully!",
  addDeliveryUser: "New member! Delivery user added successfully!",
  editDeliveryUser: "Updated! Delivery user details updated successfully!",
  deleteDeliveryUser: "Oh-ho! Delivery user deleted successfully!",
  activatedDeliveryUser: "Activated! Delivery user activated successfully!",
  deactivatedDeliveryUser:
    "Deactivated! Delivery user deactivated successfully!",
  loadingAreaSaved: "Success! Loading area details saved successfully.",
  userActivated: "Cheers! User activated successfully!",
  userDeactivated: "Quiet time! User deactivated successfully!",
  userDeleted: "Goodbye! User deleted successfully!",
  userUpdated: "Update success! User details updated successfully!",
  selectRoles:
    "No permission selected. Please choose at least one to move forward",
  productZoneAdded: "Success! Product zone added successfully.",
  productZoneUpdated: "Success! Product zone details saved successfully.",
  productZoneDeleted: "Done! Product zone deleted successfully!",
  addPicker: "New member! Picker added successfully!",
  editPicker: "Updated! Picker details updated successfully!",
  deletePicker: "Oh-ho! Picker deleted successfully!",
  activatedPicker: "Activated! Picker activated successfully!",
  deactivatedPikcer: "Deactivated! Picker deactivated successfully!",
  deletePrimaryCategory: "Primary Category deleted successfully!",
  deleteSubCategory: "Sub Category deleted successfully!",
  deleteGroupCategory: "Group Category deleted successfully!",
  allProductToast: "Search Tag update successfully",
  addTechnical: 'Technical Details added successfully!',
  editTechnical: 'Technical Details edited successfully!',
  deleteTechnical: 'Technical Details deleted successfully!',
};
